import { type SessionV2 } from "@decentriq/core";
import {
  MediaDataRoomJobInput,
  useMediaDataRoomJob,
} from "features/mediaDataRoom/hooks/v3";
import { type PublishedDatasetsHashes } from "features/mediaDataRoom/models";
import { type DataAttributesHookResult } from "../models";
import { transformDataAttributes } from "./utils";

interface DataAttributesHookPayload {
  dataRoomId: string;
  publishedDatasetsHashes: PublishedDatasetsHashes;
  session?: SessionV2;
  skip: boolean;
}

export const useDataAttributes = ({
  dataRoomId,
  publishedDatasetsHashes,
  session,
  skip,
}: DataAttributesHookPayload): DataAttributesHookResult => {
  return useMediaDataRoomJob({
    input: MediaDataRoomJobInput.create(
      "getDataAttributes",
      dataRoomId,
      publishedDatasetsHashes
    ),
    requestCreator: MediaDataRoomJobInput.emptyRequestCreator,
    session,
    skip,
    transform: transformDataAttributes,
  });
};

export default useDataAttributes;
